<div mat-dialog-content>
  <form [formGroup]="form" class="response-form">
    <!-- Cabeçalho com ícone e título -->
    <div class="dialog-header">
      <mat-icon class="client-icon">person</mat-icon>
      <h2>Responder ao Cliente</h2>
    </div>

    <!-- Informações do Cliente -->
    <div class="client-info-card">
      <div class="client-info-content">
        <div class="info-group">
          <span class="info-label">Nome do Cliente</span>
          <span class="info-value">{{data.name || 'Não informado'}}</span>
          <span class="info-label">{{data.email || 'Não informado'}}</span>
        </div>

        <!-- Grupo de informações do email
        <div class="info-group">
          <span class="info-label">Email do Cliente</span>
          <mat-form-field appearance="outline" class="email-field">
            <input matInput type="email" formControlName="email" required>
            <mat-error *ngIf="form.get('email')?.hasError('required')">Email é
              obrigatório</mat-error>
            <mat-error *ngIf="form.get('email')?.hasError('email')">Email
              inválido</mat-error>
          </mat-form-field>
        </div>
      -->
      </div>
    </div>

    <!-- Seção de Assuntos Selecionados (Categorias) -->
    <div *ngIf="hasCategories" class="subjects-section">
      <div class="section-header">
        <mat-icon class="header-icon">local_offer</mat-icon>
        <span>ASSUNTOS SELECIONADOS</span>
      </div>

      <div class="tags-container">
        <ng-container *ngFor="let question of categoryQuestions">
          <ng-container *ngIf="question.answer && question.answer.length">
            <ng-container
              *ngIf="Array.isArray(question.answer); else singleAnswer">
              <span *ngFor="let option of question.answer" class="subject-tag">
                {{option}}
              </span>
            </ng-container>
            <ng-template #singleAnswer>
              <span class="subject-tag">{{question.question}}</span>
            </ng-template>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- Seção de Perguntas e Respostas -->
    <div *ngIf="hasNormalQuestions" class="questions-section">
      <div class="questions-header">
        <mat-icon class="header-icon">question_answer</mat-icon>
        <span>CAMPOS DO FORMULÁRIO</span>
      </div>

      <div formArrayName="adminResponses">
        <div *ngFor="let question of dynamicQuestions; let i = index"
          class="question-card"
          [ngClass]="{'category-question': question.isCheckbox, 'normal-question': !question.isCheckbox}"
          [hidden]="question.isCheckbox">

          <!-- Dados da Pergunta -->
          <div class="question-info">
            <div class="form-field-label">CAMPO DO FORMULÁRIO:</div>
            <div class="question-text">{{question.question}}</div>

            <div class="user-answer-container">
              <div class="user-answer-label">RESPOSTA DO CLIENTE:</div>
              <div class="user-answer">{{question.answer ||
                'Não preenchido'}}</div>
            </div>
          </div>

          <!-- Área de Resposta do Admin (apenas para perguntas normais) -->
          <div class="admin-response-area" *ngIf="!question.isCheckbox">
            <button *ngIf="!question.showResponse"
              mat-stroked-button
              color="primary"
              class="response-button"
              (click)="toggleResponse(i)">
              <mat-icon>reply</mat-icon>
              Responder
            </button>

            <div *ngIf="question.showResponse" class="response-input-container">
              <mat-form-field appearance="outline" class="response-field">
                <mat-label>Sua resposta</mat-label>
                <textarea matInput
                  [formControlName]="i"
                  rows="3"
                  placeholder="Digite sua resposta aqui"></textarea>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mensagem quando não há perguntas para responder -->
    <div *ngIf="!hasNormalQuestions && hasCategories"
      class="no-questions-message">
      <mat-icon>info</mat-icon>
      <span>Não há perguntas disponíveis para resposta, apenas categorias
        selecionadas.</span>
    </div>

    <!-- Mensagem quando não há nenhuma pergunta ou categoria -->
    <div *ngIf="!hasNormalQuestions && !hasCategories"
      class="no-questions-message">
      <mat-icon>info</mat-icon>
      <span>Não há informações disponíveis para resposta.</span>
    </div>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-raised-button
    class="send-button"
    [disabled]="form.invalid || isLoading"
    (click)="save()">
    <mat-icon *ngIf="!isLoading">send</mat-icon>
    <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
    {{isLoading ? 'Enviando...' : 'Enviar Resposta'}}
  </button>
</div>
